var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * NotificationsDisabled component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconNotificationsDisabled extends BlocksElement {
    constructor() {
        super(...arguments);
        /**
         *
         * Append to the class name to pass classes (such as utility classes) into the internals
         */
        this.styleModifier = '';
    }
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon-notifications-disabled', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M22.5168 21.5149L18.9648 17.963H21.2417C21.606 17.963 21.9703 17.6897 21.9703 17.2343C21.9703 16.779 21.6971 16.5057 21.2417 16.5057C20.7863 16.5057 20.422 16.3236 20.0577 15.9593C19.6934 15.595 19.5113 15.1396 19.5113 14.5931V8.67318C19.5113 6.6695 18.6916 4.7569 17.2343 3.29968C15.7771 1.84246 13.8645 1.02277 11.8608 1.02277C9.85717 1.02277 7.94457 1.84246 6.48735 3.29968C6.12304 3.66398 5.75874 4.02829 5.48551 4.48367L2.20676 1.20492C1.93353 0.931693 1.47815 0.931693 1.20492 1.20492C0.931693 1.47815 0.931693 1.93353 1.20492 2.20676L21.5149 22.5168C21.606 22.6078 21.7882 22.6989 21.9703 22.6989C22.1525 22.6989 22.3346 22.6078 22.4257 22.5168C22.79 22.2435 22.79 21.7882 22.5168 21.5149ZM7.39811 4.21044C8.5821 3.02645 10.1304 2.38891 11.8608 2.38891C13.5913 2.38891 15.1396 3.02645 16.3236 4.21044C17.5076 5.39443 18.1451 6.94273 18.1451 8.67318V14.7753C18.1451 15.5039 18.3273 16.1414 18.7826 16.6879H17.6897L6.48735 5.48551C6.76057 5.03013 7.0338 4.57474 7.39811 4.21044Z"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M13.4091 21.3328H10.3125C9.94825 21.3328 9.58394 21.606 9.58394 22.0614C9.58394 22.5168 9.85717 22.79 10.3125 22.79H13.4091C13.7734 22.79 14.1378 22.5168 14.1378 22.0614C14.1378 21.606 13.7734 21.3328 13.4091 21.3328Z"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M13.3181 17.3254C13.3181 16.9611 13.0448 16.5968 12.5895 16.5968H5.03013C5.39443 16.0504 5.66766 15.4128 5.66766 14.6842V9.49286C5.66766 9.12856 5.39443 8.76425 4.93905 8.76425C4.48367 8.76425 4.21044 9.12856 4.21044 9.49286V14.6842C4.21044 15.2307 4.02829 15.6861 3.66398 16.0504C3.29968 16.4147 2.93537 16.5968 2.47999 16.5968C2.11568 16.5968 1.84246 16.9611 1.84246 17.3254C1.84246 17.6897 2.11568 18.054 2.57107 18.054H12.6805C13.0448 17.963 13.3181 17.6897 13.3181 17.3254Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property()
], BlocksIconNotificationsDisabled.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconNotificationsDisabled.prototype, "iconTitle", void 0);
__decorate([
    property()
], BlocksIconNotificationsDisabled.prototype, "size", void 0);
__decorate([
    property()
], BlocksIconNotificationsDisabled.prototype, "styleModifier", void 0);
if (customElements.get('cat-icon-notifications-disabled') === undefined) {
    customElements.define('cat-icon-notifications-disabled', BlocksIconNotificationsDisabled);
}
